<template>
  <div>
    <site-header></site-header>

    <main>
      <article :class="$style.post" class="wrap" v-if="item">
        <header :class="$style.header">
          <h1 :class="$style.title" v-html="item.title.rendered"></h1>
          <p :class="$style.meta" v-html="item.acf.description"></p>
        </header>
        <div :class="$style.body">
          <figure v-if="item.acf.vimeo_url">
            <iframe :src="getVimeoUrl" width="640" height="360" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
          </figure>
          <div v-html="item.content.rendered"></div>
        </div>
      </article>
    </main>

    <loader v-if="loading"></loader>
  </div>
</template>

<script>
  import axios from 'axios';
  import he from 'he';
  import SiteHeader from '../components/SiteHeader';
  import Loader from '../components/Loader';

  export default {
    name: 'work',

    components: {
      SiteHeader,
      Loader,
    },

    head: {
      title() {
        return {
          inner: (this.item) ? he.decode(this.item.title.rendered) : 'Loading',
        };
      },
    },

    data() {
      return {
        loading: true,
        item: null,
      };
    },

    mounted() {
      axios.get(`/api/work-items/${this.$route.params.slug}`).then((response) => {
        if (response.data.length) {
          this.loading = false;
          this.item = response.data[0];
          this.$emit('updateHead');
        } else {
          this.$router.push('/404');
        }
      }).catch(() => {
        this.$router.push('/404');
      });
    },

    computed: {
      getVimeoUrl() {
        const id = this.item.acf.vimeo_url.replace(/http(s)?:\/\/vimeo.com\//, '');

        return `https://player.vimeo.com/video/${id}`;
      },
    },
  };
</script>

<style module lang="postcss">
  .post {
    padding: 1rem;
    max-width: 50em;

    @media (width >= 50em) {
      padding: 1rem 4rem 2rem;
    }
  }

  .header {
    margin-bottom: 2rem;
    text-align: center;
  }

  .meta {
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 1.2;
    letter-spacing: 0.05rem;
    text-indent: 0.05rem;
    text-transform: uppercase;
    color: #444;
  }

  .title {
    margin-bottom: 0.25rem;
    font-size: 3rem;
    line-height: 1.25;
    font-weight: 600;
  }

  .body {
    & p, li {
      font-size: 1.1rem;
      line-height: 1.5;
    }

    & p,
    & ul,
    & ol {
      margin-bottom: 1.7rem;
    }

    & li:not(:last-child) {
      margin-bottom: 0.875rem;
    }

    & figure {
      margin: 0 0 1.7rem;
      max-width: 100%;
    }

    & figcaption {
      margin-top: 0.75rem;
      color: #999;
      font-size: 0.875rem;
    }

    & img {
      max-width: 100%;
      height: auto;
    }

    & iframe {
      width: 100%;
      height: 12rem;

      @media (width >= 33em) {
        height: 16rem;
      }

      @media (width >= 50em) {
        height: 24rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Work.vue?0bf9468b